// initial state
const state = () => ([])

// getters
const getters = {
    getStateModulesDropdown(state) {
        return state;
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setModulesDropdowns(state, payload) {
      for (var [key, value] of Object.entries(payload)) {
          state[key] = value;
      }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
